import ColorsType from '@/shared/entities/types/colors.type';
import style from '@/components/iconBase/iconBase.module.scss';
import React from 'react';
import { Icon } from 'vkit/lib/components';
import classesBuilder from 'vkit/lib/shared/utils/classesBuilder';

interface IconBaseProps {
  size?: number;
  icon?: string;
  iconImageUrl?: string;
  color?: ColorsType;
}

export const IconBase: React.FC<IconBaseProps> = ({
  size,
  icon,
  iconImageUrl,
  color = 'colorDefault',
}) => {
  return icon ? (
    <Icon color={color} name={icon} size={size} />
  ) : (
    <div
      className={classesBuilder(style, {
        iconBaseImage: true,
        [color]: Boolean(color),
      })}
      style={{
        width: size,
        height: size,
        mask: `url(${iconImageUrl}) no-repeat center / contain`,
        WebkitMask: `url(${iconImageUrl}) no-repeat center / contain`,
      }}
    />
  );
};
